import { render, staticRenderFns } from "./selectBank.vue?vue&type=template&id=0666fcf3&scoped=true"
import script from "./selectBank.vue?vue&type=script&lang=js"
export * from "./selectBank.vue?vue&type=script&lang=js"
import style0 from "./selectBank.vue?vue&type=style&index=0&id=0666fcf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0666fcf3",
  null
  
)

export default component.exports